import {csrf} from "~/lib/tools";

const UpsertWorkOrderReport = async (org_id, work_order_id, payload) => {
    let exists = payload.id;
    let url = `/dashboard/organizations/${org_id}/work_orders/${work_order_id}/reports${exists ? '/' + payload.id : ''}.json`;
    delete payload.id;
    return await fetch(
        url,
        {
            method: exists ? 'PUT' : 'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRF-Token": csrf()
            },
            body: JSON.stringify(payload),
        })
        .then(async r => {
            let json = await r.json();
            return {
                ok: r.ok,
                status: r.status,
                data: json.data,
                error: r.statusText,
                errors: json.errors
            }
        });
}
export {UpsertWorkOrderReport}